module.exports = __webpack_public_path__ + "img/img1.fa46ce12.png";